import { shellStringResources } from '../../Resources/ShellStringResources';
import { Metamodel } from '../base/model';
import { NamedCompositeValidator } from '../base/named-composite-validator';
import { NamedValidations } from '../base/named-validations';
import { Parameter } from '../base/parameter';

@Metamodel.model({
    name: 'globalParameter',
    display: [shellStringResources.GlobalParameter, shellStringResources.GlobalParametersLabel],
    referable: true,
    globalScope: true,
    constraints: {
        name: {
            required: true,
            validator: NamedCompositeValidator.CreateValidator([
                NamedValidations.KeyWordsValidator,
                NamedValidations.StartsWithNumberValidator])
        },
        defaultValue: {
            required: true,
            validator: GlobalParameter.prototype.validateDefaultValue
        }
    }
})
export class GlobalParameter extends Parameter {
}
